import '../style/select-input-number-5-AaWOn1.css'
import { defineComponent as k, useModel as f, ref as C, watch as P, openBlock as d, createElementBlock as c, unref as l, normalizeClass as y, createVNode as n, createCommentVNode as B, mergeProps as v, isRef as V, withCtx as i, renderSlot as u, withModifiers as I, createSlots as S } from "vue";
import g from "./divider.js";
import w from "./input-number.js";
import { Select as E } from "./select.js";
import M from "./spinner.js";
import { useFormItem as _ } from "./hooks/useFormItem.js";
import { useInputClass as F } from "./hooks/useInputClass.js";
const N = ["id", "aria-label"], U = {
  key: 0,
  class: "e-select-input-number__loading-mask"
}, G = /* @__PURE__ */ k({
  name: "e-select-input-number",
  __name: "select-input-number",
  props: {
    inputValue: {},
    selectValue: {},
    selectProps: {},
    inputProps: {},
    loading: { type: Boolean },
    isError: { type: Boolean },
    clearable: { type: Boolean }
  },
  setup(b) {
    const m = b, s = f(m, "selectValue"), t = f(m, "inputValue"), { formItem: p } = _(), a = C(!1), { inputClass: $ } = F("select-input-number");
    return P(s, (e) => {
      t.value = "";
    }), (e, o) => (d(), c("div", {
      id: l(p).formItemId,
      "aria-label": l(p).label,
      class: y(l($))
    }, [
      e.loading ? (d(), c("div", U, [
        n(l(M))
      ])) : B("", !0),
      n(l(E), v({
        modelValue: l(s),
        "onUpdate:modelValue": o[4] || (o[4] = (r) => V(s) ? s.value = r : null)
      }, e.selectProps, {
        "offset-distance": "0",
        "is-error": e.isError,
        focused: a.value,
        placement: "bottom-end"
      }), {
        prefix: i(() => [
          u(e.$slots, "prefix")
        ]),
        suffix: i(() => [
          n(l(g), {
            orientation: "vertical",
            class: "e-select-input-number__divider"
          }),
          n(l(w), v({
            modelValue: l(t),
            "onUpdate:modelValue": o[0] || (o[0] = (r) => V(t) ? t.value = r : null)
          }, e.inputProps, {
            "is-error": e.isError,
            clearable: e.clearable,
            onClick: o[1] || (o[1] = I(() => {
            }, ["stop"])),
            onFocus: o[2] || (o[2] = (r) => a.value = !0),
            onBlur: o[3] || (o[3] = (r) => a.value = !1)
          }), S({ _: 2 }, [
            e.$slots.inputPrefix ? {
              name: "prefix",
              fn: i(() => [
                u(e.$slots, "inputPrefix")
              ]),
              key: "0"
            } : void 0,
            e.$slots.inputSuffix ? {
              name: "suffix",
              fn: i(() => [
                u(e.$slots, "inputSuffix")
              ]),
              key: "1"
            } : void 0
          ]), 1040, ["modelValue", "is-error", "clearable"])
        ]),
        _: 3
      }, 16, ["modelValue", "is-error", "focused"])
    ], 10, N));
  }
});
export {
  G as default
};
//# sourceMappingURL=select-input-number.js.map
